// Supabase client configuration with environment-based URLs
import { createClient } from '@supabase/supabase-js';
import type { Database } from '@sylva/shared-types/database';

// Get Supabase URL and key from environment variables
const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL || "https://jtqfrzsyctjmxpcegktd.supabase.co";
const SUPABASE_ANON_KEY = import.meta.env.VITE_SUPABASE_ANON_KEY || "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Imp0cWZyenN5Y3RqbXhwY2Vna3RkIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MzU4MTU4MzEsImV4cCI6MjA1MTM5MTgzMX0.X0MF25vAjsaPZfX_i97_gdco0xcPaT0vtLmXrp43NUU";
export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_ANON_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: import.meta.env.MODE !== 'test',
    // Disable the multiple client warning in test environment
    ...(import.meta.env.MODE === 'test' && {
      debug: false,
      suppressGetSessionWarning: true
    }),
  }
});
